<template>
    <div class="content">
        <div class="content-wrap">
            <div class="top">
                <mq-layout mq="mobile">
                    <MobileMenubar></MobileMenubar>
                </mq-layout>
                <mq-layout mq="laptop+">
                    <LaptopMenubar></LaptopMenubar>
                </mq-layout>
            </div>

            <div class="container-login" align="center">
                <div class="main-text" align="center">
                    <p class="big-text" align="center" v-text="l10.All_Parents_FindPassword_Title1"></p>
                    <p class="sub-text" align="center" v-text="l10.All_Parents_FindPassword_Title1_Description1"></p>
                </div>

                <form @submit.prevent="onSubmit(email)">
                    <div class="form1">
                        <input class="user" type="email" v-model="email" align="center" :placeholder="[[ l10.All_Parents_FindPassword_Title1_InputBox1 ]]" />
                    </div>

                    <div class="next">
                        <input class="subm" type="submit" align="center" :value="[[ l10.All_Parents_FindPassword_Title1_Button1 ]]" />
                    </div>
                </form>
            </div>
        </div>

        <div class="container">
            <mq-layout mq="mobile">
                <MobileFooter></MobileFooter>
            </mq-layout>
            <mq-layout mq="laptop+">
                <LaptopFooter></LaptopFooter>
            </mq-layout>
        </div>

        <modal name="msgPopup"
            :classes="'msgPopup'"
            :clickToClose="false"
            :width="500"
            :height="'auto'">
            <div class="popup" align="center">
                <div class="content"><pre>{{msg}}</pre></div>
                <button @click="ok" class="okbutton" align="center">{{ l10.All_Parents_FindPassword_Title1_Button2 }}</button>
            </div>
        </modal>
    </div>
</template>
<script>
import LaptopMenubar from '@/components/menubar/LaptopLayout.vue'
import MobileMenubar from '@/components/menubar/MobileLayout.vue'
import LaptopFooter from "@/components/footer/FooterLaptop.vue";
import MobileFooter from "@/components/footer/FooterMobile.vue";

export default {
    name: "Recover",
    components: { LaptopMenubar, MobileMenubar, LaptopFooter, MobileFooter },
    data() {
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang]
            ? text[this.$store.state.lang]
            : text["en"];
        return {
            env: this.$store.state.env,
            l10: l10n,
            email: "",
            msg: "",
        };
    },
    methods: {
        ok() {
            this.$modal.hide('msgPopup');
        },
        onSubmit(email) {
            if (!email) return;

            const self = this;
            this.axios.post(
                this.env.protocol + this.env.urlAPI + "/account/resetPassword", {
                    email: email,
                    accountType: 'personal',
                    localeLanguage: this.$store.state.lang,
                }, {
                    headers: {
                        "content-type": "application/json; charset=UTF-8"
                    }
                }
            ).then(function (res) {
                if (!res.data.result) {
                    self.popMsg(res.data.errorCode);
                } else {
                    self.popMsg('OK');
                }
            }).catch(function (err) {
                self.popMsg('CA99');
            });
        },
        popMsg(code) {
            switch (code) {
                case "OK":
                    this.msg = this.l10.All_Parents_FindPassword_Title1_SystemMessage1;
                    break;
                case "CA01":
                    this.msg = this.l10.All_Parents_FindPassword_Title1_ErrorMessage1;
                    break;

                case "CA23":
                    this.msg = this.l10.All_Parents_FindPassword_Title1_ErrorMessage2 + this.l10.All_Parents_FindPassword_Title1_ErrorMessage6;
                    break;

                case "CA24":
                    this.msg = this.l10.All_Parents_FindPassword_Title1_ErrorMessage3 + this.l10.All_Parents_FindPassword_Title1_ErrorMessage6;
                    break;

                case "CA25":
                    this.msg = this.l10.All_Parents_FindPassword_Title1_ErrorMessage4 + this.l10.All_Parents_FindPassword_Title1_ErrorMessage6;
                    break;

                case "CA26":
                    this.msg = this.l10.All_Parents_FindPassword_Title1_ErrorMessage5 + this.l10.All_Parents_FindPassword_Title1_ErrorMessage6;
                    break;

                default:
                    this.msg = this.l10.All_Parents_FindPassword_Title1_SystemMessage2;
                    break;
            }
            this.$modal.show('msgPopup');
        },
    }
};
</script>

<style src="@/assets/account/main.css"></style>
<style scoped>

.top {
    height: 100px;
    background-color: #42c0ff;
}
.container {
    margin: 0 auto;
    height: auto;
    min-height: 100px;
    max-width: 1024px;
    background-color: #ffffff;
}
.content-wrap {
    background-color: #fffcf7;
    padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/account/Recover.vue